// @flow

export { NequiQrCode } from './nequi-qr-code';
